import React from 'react'
import { MdOutlineKeyboardArrowDown, MdInfo } from 'react-icons/md';
import '../css/signup.css';
import LemDropdown from './LemDropdown';


const SignUp = () => {

  const options = [
    {value:'Abuja'},
    {value:'Accra'},
    {value:'Cape Coast'},
    {value:'Kasoa'},
    {value:'Tema'},
    {value:'Tarkoradze'},
  ]
  const options1 = [
    {value:'+234'},
    {value:'+233'},

  ]
  const handleSignUp=()=>{

    var forms = document.getElementsByClassName('needs-validation');
    var validation = Array.prototype.filter.call(forms, function(form) {
      form.addEventListener('submit', function(event:MouseEvent) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }

  return (
    <div className='signup bg-white border p-3'>
      <h3 className='font-weight-bold'>Become a Bolt driver</h3>
      <p>If you have multiple cars or drivers <a className='link' href='#'>sign up as a fleet owner.</a></p>
      <form className="needs-validation " noValidate>
        <div className="mb-3">
          <label id='email' className='font-weight-bold' htmlFor="email">Email</label>
          <input type="text" className="form-control" id="email" placeholder='Email' required/>
          <small className='d-lg-none d-sm-block form-text text-muted'><MdInfo fontSize={16} className='mr-1'/>This will be your email</small>
          <div className="valid-feedback">
            Looks good!
          </div>
          <div className='invalid-feedback'>Email is required</div>
        </div>
        <div className='mb-3'>
          <label className='font-weight-bold'>Phone number</label>
          <div className="form-row">
            <div className="col-4" style={{height: 'fit-content'}}>
              <div className='select relative'>
                <label className='font-weight-bold' htmlFor='code'></label>
                <select className="custom-select" id="code" required>
                  <option selected value="">Select...</option>
                  {options1.map(option => <option value={option.value}>{option.value}</option>)}
                </select>
                <div className="invalid-feedback">Code is required</div>
              {/* <LemDropdown className='select w-100 ' options={options1} required/> */}
              </div>
            </div>
            <div className='col-8' style={{height: 'fit-content'}}>
              <label htmlFor='phone' style={{display:'none'}}></label>
              <input type='tel' className='form-control tel' id='phone' placeholder='Phone' required/>
              <div className="invalid-feedback">
                Phone is required
              </div>
            </div>
          </div>
        </div>
        <div className='form-group relative mb-3 relative'>
          <label id='city' className='font-weight-bold' htmlFor='city'>City</label>
          {/* <LemDropdown className='select w-100' options={options} required/> */}
          <select className="selectpicker form-control w-100" id="city" required>
            <option value="" style={{maxWidth: 'fit-content'}}>Choose...</option>
            {options.map(option => <option style={{maxWidth: 'fit-content'}} data-content={option.value} title={option.value}>{option.value}</option>)}
          </select>
          <div className='invalid-feedback'>City is required</div>
        </div>
        
        <div className="form-group">
          <div className="form-check">
            <input className="form-check-input" type="checkbox" value="" id="invalidCheck" required/>
            <label className="form-check-label" htmlFor="invalidCheck">
              I agree to Bolt's <a className='link' href='#'>Terms of Service</a> and <a className='link' href='#'>Privacy Policy</a>
            </label>
          </div>
        </div>
        <div className='form-group d-flex'>
        <button className='bolt-btn bolt-btn-submit btn btn-sm rounded-pill w-100 p-2 text-uppercase font-weight-bold' type="submit" onClick={handleSignUp}>Sign up as a Driver</button>
        </div>
      </form>
    </div>
  )
}

export default SignUp;
